"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TotalInfo = function (_a) {
    var _b, _c;
    var fee = _a.fee, totalAmount = _a.totalAmount, currency = _a.currency, _d = _a.children, children = _d === void 0 ? null : _d;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.row, " ").concat(styles_module_scss_1.default.fee) },
                react_1.default.createElement("div", null, t('fee')),
                react_1.default.createElement("div", null, "".concat((0, apps_shared_1.getCurrencySymbol)(currency)).concat((_b = Number(fee)) === null || _b === void 0 ? void 0 : _b.toFixed(2)))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                react_1.default.createElement("div", null, t('received')),
                react_1.default.createElement("div", null, "".concat((0, apps_shared_1.getCurrencySymbol)(currency)).concat((_c = Number(totalAmount || 0)) === null || _c === void 0 ? void 0 : _c.toFixed(2)))),
            children)));
};
exports.default = TotalInfo;
